import React from 'react';
import { ContactTitleWithSubtitle } from 'complexComponents/ContactTitleWithSubtitle';
import {} from '../ContactCellsTypes.types';
const ContactDetailsCell = ({ rowData }) => (React.createElement(ContactTitleWithSubtitle, { dataFullStory: true, partnershipMember: rowData }));
export default ContactDetailsCell;
